var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.7266L3.92651 13.8108L0.416975 15.9287C0.243236 16.0295 0.034748 15.9287 0.034748 15.727L0 11.7266Z",
    fill: "#7B7C7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87265 1.16712L0.104492 11.3867L4.13525 13.5046L9.90341 3.28499C10.1119 2.9152 9.9729 2.44456 9.59068 2.20925L6.98458 0.830949C6.56761 0.629247 6.08114 0.763715 5.87265 1.16712Z",
    fill: "#7B7C7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListEdit);
export default __webpack_public_path__ + "static/media/list_edit.f483a837b5a82072d7f066e3db9d6d1e.svg";
export { ForwardRef as ReactComponent };